import RtwInventoryTypes from "./actionTypes"

const INIT_STATE = {
  pageData: {
    loading: true,
    data: {}
  },
  detail: {
    loading: false,
    data: {}
  },
  saved: {
    loading: false
  },
}

const RtwInventory = (state = INIT_STATE, action) => {
  switch (action.type) {
    case RtwInventoryTypes.GET_RTW_INVENTORY_PAGES_SUCCESS:
      return {
        ...state,
        pageData: action.payload,
      }

    case RtwInventoryTypes.GET_DETAIL_RTW_INVENTORY_BY_ID_SUCCESS:
      return {
        ...state,
        detail: action.payload,
      }

    case RtwInventoryTypes.PUT_RTW_INVENTORY_SUCCESS:
      return {
        ...state,
        saved: action.payload,
      }
    default:
      return state
  }
}

export default RtwInventory
